import { render, staticRenderFns } from "./SortedItem.vue?vue&type=template&id=496ff97d&scoped=true&"
import script from "./SortedItem.vue?vue&type=script&lang=js&"
export * from "./SortedItem.vue?vue&type=script&lang=js&"
import style0 from "./SortedItem.vue?vue&type=style&index=0&id=496ff97d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ff97d",
  null
  
)

export default component.exports